import { LightningElement, api, track } from 'lwc';
import { sldsColors, sldsColorsGrouped } from '../../../utils/globalConstants';

const GROUP_ORDER = [
    'blue','cloudBlue','green','hotOrange','indigo',
    'orange','pink','purple','red','teal','violet','yellow','neutral'
];

/*const SLDS_COLORS_GROUPED_FLTRD = GROUP_ORDER.map(grp => {
    return {
        group: grp,
        colors: sldsColors.filter(colorObj => 
            colorObj.group === grp
        ).map(matched => { 
            return {...matched, colorClass: `slds-swatch ${matched.colorClass}`, group: grp} 
        })
    };
});*/

const SLDS_COLORS_GROUPED_FLTRD = ((groups, colors) => {
    const grouped = groups.map(g =>
        colors
        .filter(c => c.group === g)
        .map(c => ({ ...c, colorClass: `slds-swatch ${c.colorClass}`, group: g }))
    );
    const longest = Math.max(0, ...grouped.map(a => a.length));

    return Array.from({ length: longest }, (_, i) =>
        grouped.map(a => { return {...a[i], row: i};}
    ).filter(Boolean)
    ).flat();

})(GROUP_ORDER, sldsColors);

const SLDS_COLORS = sldsColors.map(obj => {return {...obj, colorClass: `slds-swatch ${obj.colorClass}`}});
const SLDS_COLORS_GROUPED = sldsColorsGrouped;

export default class sldsColorPicker extends LightningElement {
    static renderMode = 'light';
    
    @track isBoth = false;
    @track isCustom = false;
    @track isStandard = true;
    @track _colorEles;
    
    @track allColors = SLDS_COLORS;
    @track groupedColors = SLDS_COLORS_GROUPED_FLTRD;
    originalColor;
    
    @track _currentColor = {color: SLDS_COLORS_GROUPED[0].blue[3].color, colorClass: SLDS_COLORS_GROUPED[0].blue[3].colorClass};
    @api 
    set currentColor(value) {
        try {
            if (value) {
                const crntColor = this.findColor(value);
                this._currentColor = crntColor
                    ? {color: crntColor.color, colorClass: crntColor.colorClass}
                    : {color: SLDS_COLORS_GROUPED[0].blue[3].color, colorClass: SLDS_COLORS_GROUPED[0].blue[3].colorClass};
            } else {
                this._currentColor = {
                    color: SLDS_COLORS_GROUPED[0].blue[3].color, 
                    colorClass: SLDS_COLORS_GROUPED[0].blue[3].colorClass
                };
            }
        } catch(error) {
            console.error('Error in set currentColor() of sldsColorPicker.js: ', error);
        }
    }
    get currentColor() {
        try {
            return this._currentColor || 
                {
                    color: SLDS_COLORS_GROUPED[0].blue[3].color, 
                    colorClass: SLDS_COLORS_GROUPED[0].blue[3].colorClass
                };
        } catch(error) {
            console.error('Error in get currentColor() of sldsColorPicker.js: ', error);
        }
    }

    // ================== Public Methods ================== \\
    @api focusMe() {
        const isOpen = this.isColorPickerOpen();
        if (isOpen) {
            this.querySelector('[data-name="selectedColor"]').focus();
        } else {
            this.querySelector('slds-color-picker__summary-button').focus();
        }
    }
    @api sendValues() {
        console.log('In send Values here is this._currentColor.color: ', JSON.stringify(this._currentColor));
        return this._currentColor.color;
    }
    @api clearMe() {
        this._currentColor = null;
    }
    // ==================================================== \\
    renderedCallback() {
        if (!this._colorEles) {
            const colors = this.querySelectorAll('[data-id="colorOption"]');
            if (colors) {
                this._colorEles = Array.from(colors);
            } 
        }
        if (!this.originalColor && this._currentColor) {
            this.originalColor = this._currentColor.color;
        }
    }

    // Return colors with isSelected
    get colorOptions() {
        try {
            return SLDS_COLORS_GROUPED_FLTRD.map(colorObj => {
                return colorObj.color === this._currentColor
                    ? {...colorObj, isSelected: true}
                        : colorObj.isSelected
                    ? {...colorObj, isSelected: false}
                    : colorObj;
            })

        } catch(error) {
            console.error('Error in get colorOptions() of sldsColorPicker.js: ', error);
        }
    }

    // Find color in the selections
    findColor(colorVal) {
        try {
            return SLDS_COLORS_GROUPED.flatMap(
                group => Object.values(group)[0]
            ).find(
                c => c.color === colorVal || c.colorClass === colorVal
            );
        } catch(error) {
            console.error('Error in findColor() of sldsColorPicker.js: ', error);
        }
    }

    // Check if colorpicker has --> slds-show = open
    isColorPickerOpen() {
        try {
            const colorPicker = this.querySelector('[data-id="slds-color-picker__selector"]');
            if (colorPicker) {
                return colorPicker.classList.contains('slds-hide');
            }
        } catch(error) {
            console.error('Error in isColorPickerOpen() of sldsColorPicker.js: ', error);
        }
    }

    // open/close color picker
    toggleColorPicker() {
        try {
            const colorPicker = this.querySelector(".slds-color-picker__selector");
            if (colorPicker) {
                const oldClass = colorPicker.classList.contains('slds-hide') 
                    ? 'slds-hide' 
                    : 'slds-show';

                const newClass = oldClass === 'slds-hide' 
                    ? 'slds-show' 
                    : 'slds-hide';
                
                colorPicker.classList.remove(oldClass);
                colorPicker.classList.add(newClass);
            }
        } catch(error) {
            console.error('Error in toggleColorPicker() of sldsColorPicker.js: ', error);
        }
    }

    // Handle User color selection
    handleColorClick(event) {
        try {
            const ele = event.currentTarget;
            const colorVal = ele.dataset.value;
            if (colorVal) {
                this._currentColor = this.findColor(colorVal);
            }

            this.handleOptionFocus(ele);
        } catch(error) {
            console.error('Error in handleColorClick() of sldsColorPicker.js: ', error);
        }
    }

    handleOptionFocus(eleToFocus) {
        try {
            this._colorEles.forEach(element => {
                if (element === eleToFocus) {
                    element.setAttribute('tabIndex', 0);
                    element.focus();
                } else {
                    element.setAttribute('tabIndex', '-1');
                }
            });
        } catch(error) {
            console.error('Error in handleOptionFocus() of sldsColorPicker.js: ', error);
        }
    }

    handleColorPickerKeyDown(event) {
        try{
            const nonDefaultKeys = ['ArrowUp', 'ArrowDown', 'Enter', 'Escape'];
            if (!this._colorEles) return;


            
            if (nonDefaultKeys.some(k => k === event.key)) {
                event.preventDefault();
                event.stopPropagation();
            }

            const crntEle = event.target;

            // Find the currently focused item
            const active = document.activeElement;
            let selected = this._colorEles.findIndex(ele =>  ele === active);
            if (event && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) { 
                // Remove focus from the current item, if any
                if (event.key === 'ArrowUp') {
                    // Get the next option by moving down the arrays length (e.g. if current is 2 next is 1)
                    selected = selected - 1 < 0 
                        ? this._colorEles.length - 1
                        : selected - 1;
                } else {
                    // Get the next option by moving up the arrays length (e.g. if current is 2 next is 3)
                    selected = selected + 1 > this._colorEles.length - 1
                        ? 0
                        : selected + 1;
                }
                this.handleOptionFocus(this._colorEles[selected]);

            } else if(event.key === 'Enter') {
                this._currentColor = this.findColor(crntEle.dataset.value);
            } else if(event.key === 'Escape') {
                const trigger = this.querySelector('[data-id="slds-color-picker__selector"]');
                trigger.classList.remove('slds-show');
                trigger.classList.add('slds-hide');
            }
        } catch(error) {
            console.error('Error in handleColorPickerKeyDown() of sldsColorPicker.js: ', error);
        }
    }

    handleColorButtonKeyDown(event) {
        try {
            if (event.key === 'Enter') {
                this.toggleColorPicker();
            } else if(event.key === 'Escape') {
                if (this.isColorPickerOpen()) {
                    const btn = this.querySelector('[data-id="slds-color-picker__selector"]');
                    btn.classList.remove('slds-show');
                    btn.classList.add('slds-hide');
                }
            } else if(!this.isColorPickerOpen() && ['ArrowUp', 'ArrowDown'].some(k => event.key === k)) {
                const btn = this.querySelector('[data-id="slds-color-picker__selector"]');
                    btn.classList.remove('slds-hide');
                    btn.classList.add('slds-show');
            }
        } catch(error) {
            console.error('Error in handleColorButtonKeyDown() of sldsColorPicker.js: ', error);
        }
    }

   
    handleCancel(event) {
        if (event && event.key === 'Enter') {
            this._currentColor = this.findColor(this.originalColor);
            this.toggleColorPicker();
        } 

        if (event && !event.key) {
            this._currentColor = this.findColor(this.originalColor);
            this.toggleColorPicker();
        }
    }
    handleOkay(event) {
        if (event && event.key && event.key === 'Enter') {
            this.originalColor = this._currentColor.color;
            this.toggleColorPicker();
        } 
        if (event && !event.key) {
            this.originalColor = this._currentColor.color;
            this.toggleColorPicker();
        }
    }

}
